import type { TOC } from '@ember/component/template-only';

import WizardSourceComponent from 'webapp/components/wizard/source';

const WizardSourceRouteTemplate: TOC<object> = <template><WizardSourceComponent /></template>;

export default WizardSourceRouteTemplate;
